import { render, staticRenderFns } from "./addPrinterRuleFee.vue?vue&type=template&id=c6bf2ec2&scoped=true"
import script from "./addPrinterRuleFee.vue?vue&type=script&lang=js"
export * from "./addPrinterRuleFee.vue?vue&type=script&lang=js"
import style0 from "./addPrinterRuleFee.vue?vue&type=style&index=0&id=c6bf2ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bf2ec2",
  null
  
)

export default component.exports